module.exports = __webpack_public_path__ + "static/media/action-c.c286c1b5.jpg";